import React from 'react'
import DeleteIcon from '@material-ui/icons/Delete';
import { Resizable } from "re-resizable";
const style = {
  display: "block",
  alignItems: "center",
  justifyContent: "center",
  border: "solid 1px #ddd",
  background: "#f0f0f0"
};

const ImageCard = ({item, updateImageSize, removeItem}) => {
  let width = item.width && parseInt(item.width.substring(0, item.width.length - 2));
 const onResize = (e, direction, ref, d) =>{
  const data = {
    isText:false,
    property_id:item.property_id,
    width: width + parseInt(d.width),
  }
  updateImageSize(data);
  }
  return (
    <Resizable
   lockAspectRatio={true}
    style={style}
    handleClasses={{topRight :'rHandler rHandle-1', bottomRight:'rHandler rHandle-2', bottomLeft:'rHandler rHandle-3', topLeft:'rHandler rHandle-4'}}
    className="no-cursor custom-image"
    enable={{ top:false, right:false, bottom:false, left:false, topRight:true, bottomRight:true, bottomLeft:true, topLeft:true }}
    defaultSize={{
      width: item.width,
      height: item.height
  }}
    onResizeStop={onResize}
    
>
 <div className='handle'>
      <img src={item.image_url} alt=""/>
    </div> 
    <div className='rm-btn rm-2'><button type='button' onClick={() => removeItem(item.property_id)}><DeleteIcon/></button></div>
    </Resizable>
  )
}

export default ImageCard